var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.8125C7.65783 2.81402 6.37108 3.32671 5.42202 4.23811C4.47297 5.14951 3.93909 6.3852 3.93751 7.67411C3.9359 8.72741 4.29417 9.75213 4.95737 10.5911C4.95737 10.5911 5.09544 10.7656 5.11799 10.7908L9 15.1875L12.8839 10.7886C12.9041 10.7652 13.0426 10.5911 13.0426 10.5911L13.0431 10.5897C13.706 9.75117 14.0641 8.72692 14.0625 7.67411C14.0609 6.3852 13.527 5.14951 12.578 4.23811C11.6289 3.32671 10.3422 2.81402 9 2.8125ZM9 9.44196C8.6359 9.44196 8.27998 9.33828 7.97725 9.14403C7.67451 8.94977 7.43856 8.67367 7.29922 8.35064C7.15989 8.0276 7.12343 7.67215 7.19447 7.32922C7.2655 6.98628 7.44083 6.67128 7.69828 6.42404C7.95574 6.1768 8.28376 6.00843 8.64086 5.94022C8.99796 5.87201 9.3681 5.90702 9.70448 6.04082C10.0409 6.17462 10.3284 6.40122 10.5307 6.69194C10.7329 6.98266 10.8409 7.32446 10.8409 7.67411C10.8403 8.14279 10.6462 8.59211 10.301 8.92352C9.95594 9.25494 9.48805 9.44138 9 9.44196Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.56a141db09e014a0031a07f7fe7037e2.svg";
export { ForwardRef as ReactComponent };